import * as Yup from "yup";

export const columnOptions = [
  { value: "patient_name", label: "Patient Name", dataType: "Search_String", isEnum: false },
  { value: "medicaid_eligibility", label: "Medicaid Eligibility", dataType: "String", isEnum: true },
  { value: "assigned_to", label: "Assigned To", dataType: "String", isEnum: false },
  { value: "state", label: "State", dataType: "String", isEnum: false },
  { value: "coverage", label: "Coverage", dataType: "String", isEnum: true },
  { value: "department_approval", label: "Department Approval", dataType: "String", isEnum: true },
  { value: "household_salary", label: "Household Salary", dataType: "Numeric", isEnum: false },
  { value: "pregnant", label: "Pregnant", dataType: "String", isEnum: true },
  { value: "disable", label: "Disable", dataType: "String", isEnum: true },
  { value: "group_eligibility", label: "Group Eligibility", dataType: "String", isEnum: true },
  { value: "household_members", label: "Household Members", dataType: "Numeric", isEnum: false },
  { value: "discharged_status", label: "Discharge Status", dataType: "Bool", isEnum: false },
  { value: "stage", label: "DOA", dataType: "Date", isEnum: false }
];

export const legalImmigrationOptions = [
  { value: 'us_citizen', label: 'U.S. Citizen' },
  { value: 'green_card', label: 'Lawful Permanent Resident (Green Card)' },
  { value: 'refugee_asylee', label: 'Refugee / Asylee' },
  { value: 'visa_holder', label: 'Visa Holder (e.g., Student, Work)' },
  { value: 'undocumented', label: 'Undocumented / No Lawful Status' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' }
];


export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" }
];

export const yesNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];


export const yesNoMedicaidOptions= [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "None", label: "None" }
];

export const maritalOptions = [
  { value: "Married", label: "Married" },
  { value: "Single", label: "Single" },
  { value: "Divorced", label: "Divorced" },
  { value: "Domestic Partner", label: "Domestic Partner" },
  { value: "Widowed", label: "Widowed" }
];

const postalCodePattern = /^[0-9]{5}(?:-[0-9]{4})?$/; // U.S. postal code pattern

const SSNPattern = /^(?!000|666|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/;

export const formikAddPatient = {
  initialValues: {
    name: "",
    email: "",
    gender: null,
    dob: "",
    mrnNumber: "",
    coverage: null,
    homePhone: "",
    address: "",
    state: null,
    postalCode: "",
    city: "",
    maritalStatus: "",
    taxPayerNumber: "",
    doa: "",
    socialSecurityNumber: "",
    phone: "",
    isDisable: null,
    isPregnant: null,
    // isLegalImmigrant: null,
    departmentAprvlStatus: null,
    isUsCitizen: null,
    medicaidElegibitlyGroup: [],
    isVeterian: null
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required("Full Name is required"),
    // email: Yup.string().email("Invalid Email Format").required("Email is required"),
    gender: Yup.string().required("Gender is required"),
    dob: Yup.date().required("Date of Birth is required"),
    address: Yup.string().required("Adress is required"),
    homePhone: Yup.string().required("Home Phone is required"),
    postalCode: Yup.string().matches(postalCodePattern, "Enter a valid postal code").required("Zip Code is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    // mrnNumber: Yup.string().required("MRN Number is required"),
    // phone: Yup.string().required("Mobile Phone is required"),
    maritalStatus: Yup.string().required("Marital Status is required"),
    doa: Yup.date().required("Date of Application is required"),
    socialSecurityNumber: Yup.string().matches(SSNPattern, "Enter a valid SSN code")
  })
};


export const formikHouseHoldPatient = {
  initialValues: {
    houseHoldSize: 1,
    houseHoldIncome:null,
    members: []
  },
  validationSchema: Yup.object().shape({
    houseHoldSize: Yup.string().required("Household Size is required"),
    members: Yup.array().of(
      Yup.object().shape({
        fullName: Yup.string().required("Full Name is required"),
        relationship: Yup.string().required("Relationship is required"),
        dependent: Yup.string().required("Dependent status is required")
      })
    )
  })
};


export const DepartmentOptions = [
  { value: "New Patient", label: "New Patient" },
  { value: "Not Approved", label: "Not Approved" },
  { value: "Approved", label: "Approved" }
];

export const enrollmentOptions = [
  { value: "Not Started", label: "Not Started" },
  { value: "Started", label: "Started" },
  { value: "InProgress", label: "In-Progress" },
  { value: "Approved", label: "Approved" },
  { value: "Denied", label: "Denied" },
  { value: "Pending Decision", label: "Pending Decision" }
];

export const enrollmentCodeOptions = [
  { value: "Income", label: "Denied Due to Income" },
  { value: "Assets", label: "Denied Due to Assets" },
  { value: "Applicant Errors", label: "Denied Due to Applicant Errors" },
  { value: "Caseworker Errors", label: "Denied Due to Caseworker Errors" },
  { value: "Not Meeting Functional Need", label: "Denied Due to Not Meeting Functional Need" },
  { value: "Other Reason", label: "Denied Due to Other Reason" }
];

export const houseHoldOptions = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" }
];

export const relationShipOptions = [
  { value: "Spouse", label: "Spouse" },
  { value: "Parent", label: "Parent" },
  { value: "Sibling", label: "Sibling" },
  { value: "Child", label: "Child" },
  { value: "Friend", label: "Friend" },
  { value: "Partner", label: "Partner" },
  { value: "Guardian", label: "Guardian" },
  { value: "Grandparent", label: "Grandparent" },
  { value: "Aunt/Uncle", label: "Aunt/Uncle" },
  { value: "Cousin", label: "Cousin" },
  { value: "In-Law", label: "In-Law" },
  { value: "Neighbor", label: "Neighbor" },
  { value: "Colleague", label: "Colleague" },
  { value: "Other Relative", label: "Other Relative" }
];

export const documentsOptions = [
  { value: "Passport", label: "Passport" },
  { value: "Driver License", label: "Driver License" },
  { value: "Citizenship Proof", label: "Citizenship Proof" },
  { value: "Immigration Status Proof", label: "Immigration Status Proof" },
  { value: "Employer & Income Proof", label: "Employer & Income Proof" },
  { value: "Attestation Form", label: "Attestation Form" },
  { value: "Primary Address Proof", label: "Primary Address Proof" },
  { value: "Medicare Coverage Proof", label: "Medicare Coverage Proof" },
  { value: "Health Insurance Proof", label: "Health Insurance Proof" },
  { value: "Utility Bill Proof", label: "Utility Bill Proof" },
  { value: "Work Authorization Proof", label: "Work Authorization Proof" },
  { value: "Tax Return Proof", label: "Tax Return Proof" },
  { value: "Sworn Statement", label: "Sworn Statement" },
  { value: "Photo", label: "Photo" },
  { value: "Receipts", label: "Receipts" },
  { value: "Notice", label: "Notice" },
  { value: "Official Document", label: "Official Document" }
];

export const formikDocument = {
  initialValues: {
    documentTypeId: "",
    expirationDate: "",
    documentFile: null,
    title: ""
  },
  validationSchema: Yup.object().shape({
    documentTypeId: Yup.string().required("Document Type is required"),
    expirationDate: Yup.date().optional(),
    title: Yup.string().required("Title is required")
  })
};

export const formikAddEmergencyContactPatient = {
  initialValues: {
    name: "",
    relationship: "",
    phone: "",
    secondaryPhone: "",
    email: "",
    languagePreference: [],
    preferredContactMethod: [],
    alternateName: "",
    alternateReln: "",
    alternatePhone: "",
    alternateSecondaryPhone: "",
    alternateEmail: "",
    alternatelanguagePreference: [],
    alternatepreferredContactMethod:[]
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required("First Name is required"),
    relationship: Yup.string().required("Last Name is required")
    // phone: Yup.string().required("Phone is required"),
    // email: Yup.string().required("Email is required")
  })
};

export const languageOptions = [
  { value: "English", label: "English" },
  // { value: "Hindi", label: "Hindi" },
  { value: "Spanish", label: "Spanish" },
  { value: "Other", label: "Other" }
];

export const medicaidOptions = [
  { value: "Pregnant", label: "Pregnant" },
  { value: "Disabled", label: "Disabled" },
  { value: "Children", label: "Children (0-18)" },
  { value: "Adult", label: "Adult (19+)" }
];

export const formikAddInsurance = {
  initialValues: {
    beneficiaryName: "",
    company: "",
    policyNumber: "",
    groupNumber: "",
    planType: "",
    effectiveDate: "",
    alternateBeneficiaryName: "",
    alternateCompany: "",
    alternatePolicyNumber: "",
    alternateGroupNumber: "",
    alternatePlanType: "",
    alternateEffectiveDate: ""
  },
  validationSchema: Yup.object().shape({
    beneficiaryName: Yup.string().required("Beneficiary Name is required"),
    company: Yup.string().required("Company is required"),
    policyNumber: Yup.string().required("Policy Number is required"),
    groupNumber:  Yup.string().required("Group Number is required"),
    planType:  Yup.string().required("Plan Type is required")
  })
};

export const formikResetPass = {
  initialValues: {
      email: ""
  },
  validationSchema: Yup.object({
      email: Yup.string().email().required("Email is Required.")
  })
};

export const formikResetPatientNewPassword = {
  initialValues: {
    newPassword: "",
    confirmPassword: "",
    showPassword : true,
    showCPassword : true
  },
  validationSchema: Yup.object({
    newPassword: Yup.string()
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
      )
      .required("Required Field"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], "Passwords must match")
      .required("Please confirm your password")
  })
};

const ssnRegex = /^\d{3}-\d{2}-\d{4}$/;

export const validateRow = (row,emailSet, emailFieldIndex) => {
  const errors = [];

  // Gender validation
  const genderValues = genderOptions.map(option => option.value);
  if (row.gender && !genderValues.includes(row.gender)) {
    errors.push("Invalid gender value");
  }

  // Medicaid options validation
  const medicaidValues = yesNoMedicaidOptions.map(option => option.value);
  if (row.Medicaid && !medicaidValues.includes(row.Medicaid)) {
    errors.push("Invalid Medicaid value");
  }
    // Marital status validation
    const maritalValues = maritalOptions.map(option => option.value);
    if (row.maritalStatus && !maritalValues.includes(row.maritalStatus)) {
      errors.push("Invalid marital status");
    }
    if (row.socialSecurityNumber && !ssnRegex.test(row.socialSecurityNumber)) {
      errors.push('Invalid SSN format. Expected format: XXX-XX-XXXX');
    }
    // Department status validation
    const departmentApproval = DepartmentOptions.map(option => option.value);
    if (row.departmentAprvlStatus && !departmentApproval.includes(row.departmentAprvlStatus)) {
      errors.push("Invalid Department approval status");
    }

    const emailValue = row.email;
    if (emailValue) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        errors.push("Invalid email format");
      } else if (emailSet.has(emailValue)) {
        errors.push("Duplicate email found");
      } else {
        emailSet.add(emailValue);
      }
    }

    if (!row.homePhone) {
      errors.push("Home phone number is required");
    }

    // Boolean fields validation
  const booleanFields = [
    { key: "isVeterian", label: "Veterian status" },
    { key: "isPregnant", label: "Pregnancy status" },
    { key: "isDisable", label: "Disability status" },
    { key: "isLegalImmigrant", label: "Legal immigrant status" },
    { key: "isUsCitizen", label: "US citizenship status" }
  ];

  booleanFields.forEach(field => {
    if (
      row[field.key] !== undefined &&
      row[field.key] !== true &&
      row[field.key] !== false
    ) {
      errors.push(`Invalid ${field.label}. Expected true or false.`);
    }
  });

  return errors;
};

export const requestTypeOptions = [
  { value: "New Feature", label: "New Feature" },
  { value: "Bug", label: "Bug" },
  { value: "Enhancement", label: "Enhancement" },
  { value: "Admin Request", label: "Admin Request" }
];

export const categoryOptions = [
  { value: "User Access", label: "User Access" },
  { value: "Data Sync", label: "Data Sync" },
  { value: "UI/UX", label: "UI/UX" },
  { value: "Performance", label: "Performance" },
  { value: "Integration", label: "Integration" },
  { value: "Reporting", label: "Reporting" },
  { value: "Security", label: "Security" },
  { value: "Workflow", label: "Workflow" },
  { value: "Other", label: "Other" }
];

export const priorityOptions = [
  { value: "P1", label: "P1" },
  { value: "P2", label: "P2" },
  { value: "P3", label: "P3" },
  { value: "P4", label: "P4" }
];

export const resolutionOptions = [
  { value: "Done", label: "Done" },
  { value: "Not Reproducible", label: "Not Reproducible" },
  { value: "Not Approved", label: "Not Approved" }
];

export const statusOptions = [
  { value: "InProgress", label: "In Progress" },
  { value: "Todo", label: "To Do" },
  { value: "Completed", label: "Completed" }
];
